import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=dc4e4bcc&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"
import style0 from "./PricingSection.vue?vue&type=style&index=0&id=dc4e4bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4e4bcc",
  null
  
)

export default component.exports